import VueRouter from "vue-router";
import IndexView from "@/views/index.vue";
import AgentFinder from "@/views/AgentFinder.vue";
import ContactForm from "@/components/ContactForm.vue";
import QuoteForm from "@/components/QuoteForm.vue";
import DestinationSelector from "@/components/DestinationSelector.vue";
import AdminLogin from "@/views/AdminLogin.vue";
import AdminForgotPassword from "@/views/AdminForgotPassword.vue";
import AdminDashboard from "@/views/AdminDashboard.vue";
import AdminFolders from "@/views/AdminFolders.vue";
import FolderDetail from "@/views/FolderDetail.vue";
import FileDownload from "@/views/FileDownload.vue";
import Tutorials from "@/views/Tutorials.vue";
import PublicTutorials from "@/views/PublicTutorials.vue";
import Navigation from "@/views/Navigation.vue";
import DynamicPage from "@/views/DynamicPage.vue";
import ExternalIframeView from "@/views/ExternalIframeView.vue";
import TravelAgencies from "@/views/TravelAgencies.vue";
import VacationQuiz from "@/views/VacationQuiz.vue";

export const routes = [
  {
    path: "/",
    name: "Homepage",
    component: AdminLogin,
  },
  {
    path: "/admin",
    name: "admin-dashboard",
    component: AdminDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: "/admin/dashboard",
    name: "admin-dashboard",
    component: AdminDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: "/",
    name: "index",
    component: IndexView,
  },
  {
    path: "/agent-finder",
    name: "agent-finder",
    component: AgentFinder,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactForm,
  },
  {
    path: "/graag-een-offerte",
    name: "graag-een-offerte",
    component: QuoteForm,
  },
  {
    path: "/destination-selector",
    name: "destination-selector",
    component: DestinationSelector,
  },
  {
    path: "/vakanties",
    name: "vakanties",
    component: IndexView,
  },
  {
    path: "/vakantie-quiz",
    name: "vacation-quiz",
    component: VacationQuiz,
  },
  {
    path: "/admin/login",
    name: "admin-login",
    component: AdminLogin,
  },
  {
    path: "/admin/forgot-password",
    name: "admin-forgot-password",
    component: AdminForgotPassword,
  },
  {
    path: "/admin/folders",
    name: "admin-dashboard",
    component: AdminFolders,
    meta: { requiresAuth: true }
  },
  {
    path: "/admin/folders/:id",
    name: "folder-detail",
    component: FolderDetail,
    meta: { requiresAuth: true }
  },
  {
    path: "/download/:id",
    name: "file-download",
    component: FileDownload
  },
  {
    path: "/tutorials",
    name: "public-tutorials",
    component: PublicTutorials,
  },
  {
    path: "/admin/tutorials",
    name: "tutorials",
    component: Tutorials,
    meta: { requiresAuth: true }
  },
  // Dynamic pages using the API
  {
    path: "/admin/home",
    name: "admin-home",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: { siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "67d05b2dc3b389024e7b2476fa177565" }
  },
  // Informatie section routes
  {
    path: "/admin/agentmails",
    name: "agentmails",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "38a4042be36873fef22b54e0c026a4f2" }
  },
  {
    path: "/admin/agenda",
    name: "agenda",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "3dac180abf9f2cb3257b6d0aa80859b4" }
  },
  {
    path: "/admin/tui-statistieken",
    name: "tui-statistieken",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "b5c26ba6ea7f3db6b13337c93f039652", enableUTDInit: true }
  },
  {
    path: "/admin/statuten-en-reglementen",
    name: "statuten-en-reglementen",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "645d7b47768d183316d7f0979112f122", enableUTDInit: true }
  },
  {
    path: "/admin/ledenvoordelen",
    name: "ledenvoordelen",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "2caf127ee2af4ba7f53ac2f1ff6f021a", enableUTDInit: true, showInSidebar: true }
  },
  {
    path: "/admin/wie-is-wie",
    name: "wie-is-wie",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "047696ce027dd0377ea52a2fc2a6abea" }
  },
  // Partners route
  {
    path: "/admin/partners",
    name: "partners",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "41fc2b623aee7293edbe5714d0bb63ae", showInSidebar: true }
  },
  // Marketing section routes
  {
    path: "/admin/materiaal-bestellen-via-staci",
    name: "materiaal-bestellen-via-staci",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "0d94edb84938888b8cc95fdcf5dadca4" }
  },
  {
    path: "/admin/beeldmateriaal",
    name: "beeldmateriaal",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "7b1edf681a64668216bf74290fed3b90", enableUTDInit: true }
  },
  {
    path: "/admin/nieuwsbrief",
    name: "nieuwsbrief",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "254e11d815ba4bfee08f10c448b456e2" }
  },
  {
    path: "/admin/cadeaubonnen",
    name: "cadeaubonnen",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "9bd281cbc64767665925bc5e8dc6f730", enableUTDInit: true }
  },
  {
    path: "/admin/postkaartjes",
    name: "postkaartjes",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "6484ec0203d6783d3d75d8267ae503a4" }
  },
  {
    path: "/admin/webinars",
    name: "webinars",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "9af2f1a50cdc8f4862047f017ae62799" }
  },
  {
    path: "/admin/brochures-bestellen",
    name: "brochures-bestellen",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "63a2009ba72c0e9bfe528c3bdb8ca972" }
  },
  // Other navigation routes
  {
    path: "/admin/handleidingen",
    name: "handleidingen",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "cc2a335e911512dfbba606b354b5f45a", enableUTDInit: true }
  },
  {
    path: "/admin/incentives",
    name: "incentives",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "ae062c9582357384604a1b36686d3883" }
  },
  {
    path: "/admin/wetgeving",
    name: "wetgeving",
    component: DynamicPage,
    meta: { requiresAuth: true },
    props: {siteId: "dcd2ea7d1da3e305bc394652d738c07e", pageId: "4e808602c9bfe9069db9aed0bbbfe614", enableUTDInit: true }
  },
  // Travel Agencies management
  {
    path: "/admin/reisbureaus",
    name: "travel-agencies",
    component: TravelAgencies,
    meta: { requiresAuth: true }
  },
  // Example: External iframe route with access control
  {
    path: "/admin/users",
    name: "users",
    component: ExternalIframeView,
    meta: { requiresAuth: true },
    props: {
      baseUrl: "https://auth.uptodateconnect.com",
      allowedRoles: [], // Empty array = all authenticated users can access (for testing)
      deniedMessage: "You don't have access to this service.",
    }
  },
];

const router = new VueRouter({
  // mode: "history",
  routes,
});

// Route guard for admin authentication
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      next('/admin/login');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
